import { ReactNode } from 'react';
import { StylesProp, splitStylesProp } from '../../helpers';
import { PopoverMenu, PopoverMenuProps } from '../popover';

export const ComboboxBase = <T extends HTMLElement = HTMLElement>({
  Input,
  menuProps,
  children,
  menuStyles,
}: {
  Input: ReactNode;
  menuProps: Omit<PopoverMenuProps<T>, 'initialFocus' | 'children'>;
  children: ReactNode;
  menuStyles?: StylesProp;
}) => {
  const { css: splitCss, className: splitClassName } = splitStylesProp(menuStyles);

  return (
    <>
      {Input}
      <PopoverMenu css={splitCss} className={splitClassName} {...menuProps} initialFocus={-1}>
        {children}
      </PopoverMenu>
    </>
  );
};
